export default __webpack_public_path__ + "static/media/gdzie-kupic.9bcbc6ba.png";